import { useEffect, type ReactNode } from "react";
import { X } from "lucide-react";

const WIDTH = 480;

export function DetailPanel({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children?: ReactNode;
}) {
  useEffect(() => {
    if (!open) return;
    function handleKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  return (
    <aside
      className="h-full overflow-hidden bg-surface border-l border-border flex flex-col shrink-0 transition-[width] duration-260 ease-[cubic-bezier(0.2,0,0,1)]"
      style={{ width: open ? WIDTH : 0 }}
      aria-label={title}
      aria-hidden={!open}
    >
      <div className="flex flex-col h-full" style={{ width: WIDTH }}>
          <div className="flex items-center justify-between h-10 px-4 border-b border-border shrink-0">
            <span className="text-base font-normal text-primary truncate">
              {title}
            </span>
            <button
              onClick={onClose}
              className="p-1 rounded-md text-muted hover:text-primary hover:bg-surface-elevated transition-colors cursor-pointer shrink-0"
              aria-label="Close panel"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
          <div className="flex-1 min-h-0 overflow-y-auto">{children}</div>
        </div>
    </aside>
  );
}
